<template>
  <PageLayout>
    <div class="d-flex align-center justify-space-between">
      <h2 class="text-h3 font-weight-bold pb-4">
        Publika
      </h2>

      <v-btn small rounded text color="navy" @click="loadAudiences(true)">
        <v-icon left>mdi-refresh</v-icon>
        Aktualizovat
      </v-btn>
    </div>

    <div class="mb-6 d-flex justify-space-between align-center">
      <v-btn
        medium
        outlined
        elevation="0"
        color="amber"
        class="c-btn"
        @click="onNewAudienceClick"
      >
        <v-icon left>mdi-plus</v-icon>
        Přidat nové publikum
      </v-btn>
    </div>

    <v-card elevation="0">
      <div class="d-flex px-4 py-4 mb-4">
        <v-tabs background-color="transparent" class="c-tabs">
          <!--          <v-tab v-for="filter in filters" :key="filter.value">-->
          <!--            {{ filter.text }}-->
          <!--          </v-tab>-->
        </v-tabs>
        <div style="max-width: 200px" class="ml-auto">
          <v-select
            outlined
            dense
            :items="temperatures"
            v-model="temperature"
            placeholder="Filtrujte teplotu"
            hide-details
          />
        </div>
      </div>
      <v-data-table
        :items="audiencesFiltered"
        :headers="headers"
        :loading="loading"
        :custom-sort="customSort"
        item-key="id"
        class="c-data-table c-data-table--alternate"
      >
        <template #item.name="{ item }">
          <div class="py-3">
            <div class="mb-1">{{ item.name }}</div>

            <!--            <div class="mx-n2">-->
            <!--              <v-btn small rounded text color="navy">-->
            <!--                <v-icon left>mdi-plus-circle-outline</v-icon>-->
            <!--                Vytvořit reklamu-->
            <!--              </v-btn>-->
            <!--            </div>-->
          </div>
        </template>
        <template #item.temperature="{ item }">
          <ui-temperature-chip
            v-if="item.template"
            :template-type="item.template.type"
          />
        </template>
        <template #item.type="{item}">
          <div>{{ getAudienceType(item) }}</div>
          <!--          <div class="body-1 grey&#45;&#45;text">Stránka blacktag.digital</div>-->
        </template>
        <template #item.size="{ item }">
          <span v-if="item.approximateCountLowerBound > 0">
            {{ item.approximateCountLowerBound.toLocaleString() }}
          </span>
        </template>
        <template #item.createdAt="{ item }">
          <div v-if="item.createdAt">
            <div>
              <ui-datetime date :value="item.createdAt" />
            </div>
            <div class="body-1 grey--text">
              <ui-datetime time :value="item.createdAt" />
            </div>
          </div>
          <div v-else-if="item.timeUpdated">
            <div>
              <ui-datetime
                date
                :value="getDateFromTimestamp(item.timeUpdated)"
              />
            </div>
            <div class="body-1 grey--text">
              <ui-datetime
                time
                :value="getDateFromTimestamp(item.timeUpdated)"
              />
            </div>
          </div>
        </template>
        <template #item.actions>
          <ui-table-actions :actions="actions" />
        </template>
      </v-data-table>
    </v-card>
  </PageLayout>
</template>

<script>
import { call, get, sync } from "vuex-pathify"

import PageLayout from "@/components/page/home/PageLayout.vue"
import Toastification from "../../components/ui/Toastification"
import { TEMPLATES_TYPES } from "@/store/modules/audiences-templates/defaults"
import { createCustomSort } from "../../helpers/table"
import { getDateFromTimestamp } from "../../helpers/date"

const TEMPERATURES = [
  {
    value: "all",
    text: "Vše",
    color: "green",
  },
  {
    value: "customers",
    text: "Zákazníci",
    color: "green",
  },
  {
    value: "hot",
    text: "Horké",
    color: "red",
  },
  {
    value: "warm",
    text: "Ohřáté",
    color: "amber",
  },
  {
    value: "lukewarm",
    text: "Vlažné",
    color: "indigo",
  },
]

const headers = [
  { text: "Název", value: "name" },
  { text: "Teplota", value: "temperature" },
  { text: "Typ", value: "type" },
  { text: "Velikost", value: "size" },
  { text: "Vytvořeno", value: "createdAt" },
  { text: "", value: "actions", sortable: false, align: "end" },
]

const filters = [
  { text: "Vše", value: "all" },
  { text: "Cílené", value: "targeted" },
  { text: "Vlastní", value: "custom" },
  { text: "Podobné", value: "similar" },
  { text: "Rozepsané", value: "drafts" },
]

const actions = [
  {
    text: "Upravit",
    icon: "mdi-pencil-outline",
    disabled: true,
    tooltip: "Úprava okruhů uživatelů bude přístupná v příští verzi",
  },
  {
    text: "Smazat",
    icon: "mdi-delete-outline",
    iconClass: "red--text",
    textClass: "red--text",
    disabled: true,
    tooltip: "Mazání okruhů uživatelů bude přístupno v příští verzi",
  },
]

function getAudienceType(audience) {
  if (audience && audience.audienceType) {
    switch (audience.audienceType) {
      case "targeting":
        return "Cílení"
      case "audience":
        switch (audience.audienceSubType) {
          case "setOf":
          case "saved":
            return "Vlastní okruh uživatelů"
          case "template":
            return "Vlastní okruh uživatelů ze šablony"
          case "lookalike":
            return "Podobný okruh uživatelů"
        }
    }
  } else if (audience && audience.subtype) {
    switch (audience.subtype) {
      case "WEBSITE":
        return "Vlastní okruh uživatelů"
      case "LOOKALIKE":
        return "Podobný okruh uživatelů"
    }

    return ""
  }
}

export default {
  name: "AudiencesIndex",
  components: {
    PageLayout,
  },
  data() {
    return {
      // audiences,
      headers,
      temperatures: TEMPERATURES,
      temperature: "all",
      filters,
      actions,
      TEMPLATES_TYPES,
    }
  },
  computed: {
    ...get("audiences", ["audiences", "loading"]),
    audiencesFiltered() {
      return this.audiences
        .map(audience => {
          if (audience.temperature) {
            audience = {
              ...audience,
              template: {
                type: this.TEMPLATES_TYPES[
                  this.TEMPLATES_TYPES.findIndex(
                    item => item.temperature === audience.temperature
                  )
                ],
              },
            }
          }
          return audience
        })
        .filter(audience => {
          if (this.temperature === "all") {
            return true
          } else
            return (
              audience.template &&
              this.temperature === audience.template.type.temperature
            )
        })
    },
  },
  methods: {
    ...call("audiences", ["clearAudienceModel", "loadAudiences"]),
    getAudienceType,
    customSort: createCustomSort({
      type: {
        type: "string",
        transform: (_, audience) => getAudienceType(audience),
      },
      createdAt: {
        type: "number",
        transform: (_, audience) =>
          audience.createdAt
            ? new Date(audience.createdAt).valueOf()
            : audience.timeUpdated * 1000,
      },
    }),
    getDateFromTimestamp,
    onNewAudienceClick() {
      this.clearAudienceModel()
      this.$router.push("/audiences/new")
    },
  },
  mounted() {
    if (this.$route.query.success !== undefined) {
      this.$toast.success({
        component: Toastification,
        props: {
          title: "Publikum uloženo",
          text: "Vaše publikum bylo úspěšně uloženo",
        },
      })
    }
    this.loadAudiences(true)
  },
}
</script>
